import '../appComponents/desktop/css/DesktopModalStyles.css';
import '../appComponents/shared/css/PlatformExperience.css';
import './css/RegisterWideLayout.css';
import React, { Component } from 'react';
import './css/RegisterFieldPolish.css';

class RegisterDesktopRender extends Component {
  render() {
    const { API, AWS, Amplify, Auth, Buffer, Button, ButtonContent, ButtonGroup, CampaignContract_latest, CampaignFactoryContract_latest, Component, Container, CryptoJS, Dropdown, DropdownMenu, Form, FormField, Fragment, Header, Icon, Image, Input, LENDERBLOCKADMINWHITELIST, Link, List, ListContent, ListDescription, ListHeader, ListIcon, ListItem, ListList, LoadingIcons, Modal, Mosaic, OrbitProgress, Radio, React, Storage, ThreeDot, Web3, applicantUsername, awsconfig, axios, axiosDoubleCallCounter, bip39, blenderCommissionPublicKey, blenderTransfersToPublicKey, checkValidAccountInterval, checkValidAuthTokenInterval, checkValidAuthTokenIntervalPeriod_ms, className, cognitoID, countryCodesJSON, createAccountTimer, currentUser, deploymentAddressLatest, ethers, isMobile, mimemessage, mode_light_dark, navigationHandler, primaryLanguage, region, register, routeProps, secretName, startCount, that, tokenLifeTimeLimit, touched, useParams, useRef, web3, weiBalance } = this.props;

    return (
(
            <div className={"pageBody tbp-platform tbp-platform--" + "dark" + " tbp-platform--register tbp-platform--desktop"}>
              {/* Registration styles stay with this render file. */}
              <style>{`
/* Registration uses normal document flow rather than viewport-positioned fields. */
.tbp-register-sidebar {
  width: 220px !important;
  min-height: 100vh;
  height: auto !important;
  padding: 36px 24px !important;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start !important;
  gap: 36px;
}
.tbp-register-sidebar img {
  position: static !important;
  width: 112px !important;
  height: 112px !important;
  border-radius: 50% !important;
  margin: 0 !important;
}
.tbp-register-sidebar div {
  position: static !important;
  width: 100% !important;
  height: auto !important;
  margin: 0 !important;
}
.tbp-register-sidebar button { height: auto !important; }
.tbp-register-form {
  width: min(680px, calc(100vw - 260px)) !important;
  height: auto !important;
  min-height: 100vh;
  padding: 36px 40px 56px !important;
  box-sizing: border-box;
  font-family: Lato, Arial, sans-serif;
}
.tbp-register-heading {
  width: 100% !important;
  height: auto !important;
  padding: 0 0 22px !important;
  margin: 0 0 24px !important;
  border-bottom-color: rgba(177, 177, 177, 0.35) !important;
}
.tbp-register-heading p { margin: 0 !important; line-height: 1.35; }
.tbp-register-body, .tbp-register-body div {
  position: static !important;
  top: auto !important;
  width: 100% !important;
  height: auto !important;
  min-height: 0 !important;
  max-height: none !important;
  margin: 0 !important;
  padding: 0 !important;
  display: block !important;
  overflow: visible !important;
  transform: none !important;
  box-sizing: border-box;
}
.tbp-register-body p {
  margin: 0 0 20px !important;
  line-height: 1.55;
}
.tbp-register-body input, .tbp-register-body .ui.selection.dropdown {
  width: 100% !important;
  min-height: 52px !important;
  height: auto !important;
  max-height: none !important;
  padding: 16px !important;
  margin: 0 0 18px !important;
  border: 1px solid rgba(177, 177, 177, 0.4) !important;
  border-radius: 0 !important;
  background: rgba(226, 226, 226, 1) !important;
  color: #222 !important;
  font: 600 16px Lato, Arial, sans-serif !important;
  box-sizing: border-box;
}
.tbp-register-body input:focus, .tbp-register-body .ui.dropdown:focus {
  outline: none !important;
  outline-offset: 2px;
}
.tbp-register-body .tbp-register-names {
  display: grid !important;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  column-gap: 16px;
}
/* Preserve Semantic UI's menu positioning and scrolling independently of form wrappers. */
.tbp-register-body .ui.dropdown .menu {
  display: none !important;
  position: absolute !important;
  top: 100% !important;
  max-height: 260px !important;
  overflow-y: auto !important;
  z-index: 20;
}
.tbp-register-body .ui.dropdown.active.visible .menu { display: block !important; }
.tbp-register-body .ui.dropdown .item { padding: 12px 16px !important; }
.tbp-register-body .ui.dropdown .text { width: auto !important; }
.tbp-register-body .tbp-register-action { margin-top: 10px !important; }
.tbp-register-body .tbp-register-action button {
  width: 100% !important;
  height: auto !important;
  min-height: 52px !important;
  padding: 14px 20px !important;
  border-radius: 0 !important;
  background: #009e81 !important;
  color: white !important;
}
.tbp-register-body .tbp-register-action button p {
  margin: 0 !important;
  color: white !important;
  font-size: 17px !important;
}
@media (max-width: 800px) {
  .tbp-register-sidebar { width: 140px !important; padding: 28px 16px !important; }
  .tbp-register-sidebar img { width: 80px !important; height: 80px !important; }
  .tbp-register-form { width: calc(100vw - 160px) !important; padding: 28px 24px !important; }
}
@media (max-width: 520px) {
  .tbp-register-sidebar { display: none !important; }
  .tbp-register-form { width: 100vw !important; padding: 24px !important; }
  .tbp-register-body .tbp-register-names { grid-template-columns: 1fr; }
}
.tbp-register-body .ui.selection.dropdown { position: relative !important; }
/* Country picker: the same rectangular field, with a contained searchable list. */
.tbp-register-body .ui.selection.dropdown.tbp-register-country {
  display: block !important;
  padding: 16px 42px 16px 16px !important;
  line-height: 20px !important;
  border-radius: 0 !important;
  cursor: pointer;
}
.tbp-register-body .tbp-register-country > .dropdown.icon {
  top: 17px !important;
  right: 16px !important;
  padding: 0 !important;
  color: #555;
}
.tbp-register-body .tbp-register-country > input.search {
  position: absolute !important;
  top: 0 !important;
  left: 0 !important;
  height: 52px !important;
  min-height: 52px !important;
  padding: 16px 42px 16px 16px !important;
  margin: 0 !important;
  border: none !important;
  outline: none !important;
  background: transparent !important;
}
.tbp-register-body .tbp-register-country > .menu {
  top: calc(100% + 6px) !important;
  width: 100% !important;
  min-width: 0 !important;
  border: 1px solid #b8b8b8 !important;
  border-radius: 0 !important;
  background: #e2e2e2 !important;
  color: #222 !important;
  box-shadow: 0 8px 24px rgba(0,0,0,0.18) !important;
}
.tbp-register-body .tbp-register-country .menu > .item {
  padding: 12px 16px !important;
  min-height: 44px !important;
  color: #222 !important;
  font: 400 16px Lato, Arial, sans-serif !important;
  white-space: normal !important;
}
.tbp-register-body .tbp-register-country .menu > .item:hover,
.tbp-register-body .tbp-register-country .menu > .selected.item {
  background: #c7dbd7 !important;
}
.tbp-register-body.tbp-register-mobile-body {
  width: calc(100% - 48px) !important;
  margin: 24px auto 40px !important;
}

.tbp-register-body input, .tbp-register-body button {
  pointer-events: auto !important;
  position: relative;
  z-index: 1;
  border-radius: 0 !important;
}
.tbp-register-body input { user-select: text !important; }

/* Compact Register-only dialogs; shared overlays on other pages are untouched. */
.ui.page.dimmer.tbp-register-backdrop { display: flex !important; align-items: flex-start !important; justify-content: center !important; padding: 32px 20px !important; overflow-y: auto !important; }
.ui.modal.tbp-register-overlay { position: relative !important; inset: auto !important; width: min(520px, 100%) !important; max-width: 520px !important; height: auto !important; margin: 0 auto !important; padding: 24px !important; border-radius: 5px !important; box-sizing: border-box !important; font-family: Lato, Arial, sans-serif !important; }
.ui.modal.tbp-register-overlay.dark { background: #3e4349 !important; color: #fff !important; }
.ui.modal.tbp-register-overlay.light { background: #eaeaea !important; color: #222 !important; }
.tbp-register-overlay .header, .tbp-register-overlay .content, .tbp-register-overlay .actions { background: transparent !important; color: inherit !important; border: 0 !important; padding: 0 !important; margin: 0 !important; width: 100% !important; box-sizing: border-box !important; }
.tbp-register-overlay .header { font-size: 22px !important; line-height: 1.35 !important; margin-bottom: 20px !important; }
.tbp-register-overlay h3 { font-size: 17px !important; line-height: 1.5 !important; margin: 0 0 20px !important; color: inherit !important; }
.tbp-register-overlay p, .tbp-register-overlay .tbp-register-message { font-size: 16px !important; line-height: 1.5 !important; overflow-wrap: anywhere; color: inherit; margin: 0 0 16px !important; }
.tbp-register-overlay .tbp-register-modal-buttons { display: flex; flex-direction: column; gap: 12px; }
.tbp-register-overlay .ui.button { width: 100% !important; min-height: 48px !important; height: auto !important; border-radius: 0 !important; padding: 12px 16px !important; margin: 0 !important; background: #009e81 !important; color: #fff !important; font: 600 16px/1.5 Lato, Arial, sans-serif !important; white-space: normal !important; box-sizing: border-box !important; }
.tbp-register-overlay .ui.button.tbp-register-secondary { background: #62676d !important; }
.tbp-register-overlay input { width: 100% !important; height: 48px !important; padding: 12px !important; margin: 0 0 16px !important; border: 1px solid #999 !important; border-radius: 0 !important; background: #e2e2e2 !important; color: #222 !important; text-align: center; letter-spacing: 6px; font: 600 20px Lato, Arial, sans-serif; box-sizing: border-box; }
.tbp-register-body input:focus, .tbp-register-body .ui.dropdown:focus, .tbp-register-overlay input:focus { outline: none !important; box-shadow: none !important; border-color: #888 !important; }
.tbp-register-overlay .tbp-register-error { color: #ffa5a5 !important; }
.tbp-register-overlay.light .tbp-register-error { color: #b52626 !important; }
.tbp-register-loading { display: flex; flex-direction: column; align-items: center; gap: 16px; padding: 24px 0; text-align: center; font-size: 16px; }
.tbp-register-spinner { display: inline-block; width: 28px; height: 28px; border: 3px solid rgba(177,177,177,.4); border-top-color: currentColor; border-radius: 50%; animation: tbp-register-spin .8s linear infinite; }
@keyframes tbp-register-spin { to { transform: rotate(360deg); } }

/* Keep the opaque Country list above the Continue button. */
.tbp-register-body .ui.selection.dropdown.tbp-register-country {
  position: relative !important;
  z-index: 30 !important;
  opacity: 1 !important;
}
.tbp-register-body .tbp-register-country > .menu {
  z-index: 31 !important;
  background: #e2e2e2 !important;
  opacity: 1 !important;
  filter: none !important;
  backdrop-filter: none !important;
}
.tbp-register-body .tbp-register-country .menu > .item {
  background: #e2e2e2 !important;
  opacity: 1 !important;
}
.tbp-register-body .tbp-register-country .menu > .item:hover,
.tbp-register-body .tbp-register-country .menu > .selected.item,
.tbp-register-body .tbp-register-country .menu > .active.item {
  background: #c7dbd7 !important;
}
.tbp-register-body .tbp-register-action,
.tbp-register-body .tbp-register-action button {
  position: relative !important;
  z-index: 0 !important;
}
              `}</style>

              <style>{`
.tbp-platform--register {
  min-height: 100vh !important;
  background: radial-gradient(circle at 18% 18%, rgba(20, 140, 121, 0.24) 0%, rgba(20, 140, 121, 0.08) 18%, rgba(3, 14, 31, 0) 42%), linear-gradient(90deg, #02091b 0%, #071633 48%, #02091b 100%) !important;
  overflow-x: hidden !important;
}
.tbp-platform--register.tbp-platform--desktop {
  display: grid !important;
  grid-template-columns: 120px minmax(0, 1fr) !important;
}
.tbp-platform--register.tbp-platform--mobile {
  display: block !important;
}
.tbp-platform--register .tbp-register-sidebar {
  width: auto !important;
  min-height: 100vh !important;
  padding: 24px 18px !important;
  background: linear-gradient(180deg, rgba(9, 24, 49, 0.88) 0%, rgba(8, 24, 48, 0.66) 100%) !important;
  border-right: 1px solid rgba(112, 146, 181, 0.2) !important;
  align-items: center !important;
  justify-content: flex-start !important;
  gap: 22px !important;
  position: relative !important;
}
.tbp-platform--register .tbp-register-sidebar img {
  width: 82px !important;
  height: 82px !important;
  border-radius: 20px !important;
  border: 1px solid rgba(143, 171, 204, 0.32) !important;
  box-shadow: 0 18px 50px rgba(0,0,0,.25) !important;
}
.tbp-platform--register .tbp-register-sidebar .flipContainer {
  position: static !important;
  margin-top: 4px !important;
  width: 100% !important;
  height: auto !important;
}
.tbp-platform--register .tbp-register-sidebar .flipContainer > div {
  width: 100% !important;
  height: auto !important;
}
.tbp-platform--register .tbp-register-sidebar .ui.button {
  width: 100% !important;
  justify-content: flex-start !important;
  padding: 10px 12px !important;
  border-radius: 12px !important;
  border: 1px solid rgba(130, 159, 190, 0.16) !important;
  background: rgba(255,255,255,0.02) !important;
}
.tbp-platform--register .tbp-register-sidebar .ui.button:hover {
  background: rgba(19,188,153,0.08) !important;
  border-color: rgba(19,188,153,0.18) !important;
}
.tbp-platform--register .tbp-register-form {
  width: auto !important;
  min-height: 100vh !important;
  padding: 42px clamp(24px, 4vw, 48px) 86px !important;
  display: flex !important;
  flex-direction: column !important;
  justify-content: center !important;
  align-items: center !important;
  box-sizing: border-box !important;
}
.tbp-platform--register .tbp-register-heading,
.tbp-platform--register .tbp-register-body,
.tbp-platform--register .tbp-register-mobile-body {
  width: min(720px, 100%) !important;
  margin-left: auto !important;
  margin-right: auto !important;
}
.tbp-platform--register .tbp-register-heading {
  height: auto !important;
  display: block !important;
  padding: 0 !important;
  margin: 0 0 16px !important;
  border: 0 !important;
}
.tbp-platform--register .tbp-register-hero {
  padding: 0 4px 0 !important;
}
.tbp-platform--register .tbp-register-kicker {
  margin: 0 0 10px !important;
  font-size: 12px !important;
  font-weight: 800 !important;
  letter-spacing: .28em !important;
  color: #20d0ac !important;
  text-transform: uppercase !important;
}
.tbp-platform--register .tbp-register-title {
  margin: 0 0 10px !important;
  font-size: clamp(30px, 4vw, 44px) !important;
  line-height: 1.05 !important;
  font-weight: 800 !important;
  letter-spacing: -0.03em !important;
  color: #edf4fb !important;
}
.tbp-platform--register .tbp-register-subtitle {
  margin: 0 !important;
  font-size: 16px !important;
  line-height: 1.6 !important;
  color: rgba(213, 226, 240, 0.78) !important;
  max-width: 56ch !important;
}
.tbp-platform--register .tbp-register-body,
.tbp-platform--register .tbp-register-mobile-body {
  background: linear-gradient(180deg, rgba(19, 41, 69, 0.96) 0%, rgba(15, 33, 56, 0.94) 100%) !important;
  border: 1px solid rgba(102, 139, 178, 0.24) !important;
  border-radius: 24px !important;
  padding: 30px 30px 28px !important;
  box-shadow: 0 26px 60px rgba(4, 17, 31, 0.28) !important;
}
.tbp-platform--register .tbp-register-body > div:first-child > p,
.tbp-platform--register .tbp-register-mobile-body > div:first-child > p:first-child {
  margin-bottom: 16px !important;
  font-size: 15px !important;
  line-height: 1.55 !important;
  color: rgba(213, 226, 240, 0.82) !important;
}
.tbp-platform--register .tbp-register-body input,
.tbp-platform--register .tbp-register-body .ui.selection.dropdown {
  background: rgba(22, 42, 71, 0.88) !important;
  border: 1px solid rgba(100, 131, 164, 0.32) !important;
  color: #edf4fb !important;
  border-radius: 14px !important;
  min-height: 56px !important;
  font-size: 16px !important;
  box-shadow: inset 0 1px 0 rgba(255,255,255,.03) !important;
}
.tbp-platform--register .tbp-register-body input::placeholder {
  color: rgba(191, 206, 223, 0.62) !important;
}
.tbp-platform--register .tbp-register-body .tbp-register-country > .dropdown.icon { color: rgba(215, 228, 242, .8) !important; }
.tbp-platform--register .tbp-register-body .tbp-register-country > .menu {
  background: #132645 !important;
  border: 1px solid rgba(100, 131, 164, 0.32) !important;
  border-radius: 16px !important;
  box-shadow: 0 22px 44px rgba(1,9,19,.32) !important;
}
.tbp-platform--register .tbp-register-body .tbp-register-country .menu > .item {
  color: #edf4fb !important;
  background: transparent !important;
}
.tbp-platform--register .tbp-register-body .tbp-register-country .menu > .item:hover,
.tbp-platform--register .tbp-register-body .tbp-register-country .menu > .selected.item,
.tbp-platform--register .tbp-register-body .tbp-register-country .menu > .active.item {
  background: rgba(19,188,153,.16) !important;
}
.tbp-platform--register .tbp-register-body .tbp-register-action { margin-top: 10px !important; }
.tbp-platform--register .tbp-register-body .tbp-register-action button {
  min-height: 56px !important;
  border-radius: 14px !important;
  border: 1px solid rgba(12, 179, 144, 0.54) !important;
  background: linear-gradient(180deg, #16c8a2 0%, #0fa786 100%) !important;
  box-shadow: none !important;
}
.tbp-platform--register .tbp-register-body .tbp-register-action button p {
  color: #05293f !important;
  font-weight: 800 !important;
}
.tbp-platform--register .tbp-register-overlay {
  border-radius: 22px !important;
  border: 1px solid rgba(102,139,178,0.24) !important;
  box-shadow: 0 28px 64px rgba(4,17,31,.34) !important;
}
.tbp-platform--register .tbp-register-overlay.dark {
  background: linear-gradient(180deg, rgba(19,41,69,0.98), rgba(13,31,53,0.96)) !important;
}
.tbp-platform--register .tbp-register-overlay .ui.button {
  border-radius: 14px !important;
  background: linear-gradient(180deg, #16c8a2 0%, #0fa786 100%) !important;
  color: #06263c !important;
  font-weight: 800 !important;
}
.tbp-platform--register .tbp-register-overlay .ui.button.tbp-register-secondary {
  background: rgba(255,255,255,.08) !important;
  color: #edf4fb !important;
}
.tbp-platform--register .tbp-register-overlay input {
  background: rgba(22,42,71,.9) !important;
  color: #edf4fb !important;
  border: 1px solid rgba(100,131,164,.34) !important;
  border-radius: 14px !important;
}
.tbp-platform--register .tbp-register-footer {
  position: fixed !important;
  left: 140px !important;
  right: 20px !important;
  bottom: 16px !important;
  display: flex !important;
  justify-content: center !important;
  gap: 38px !important;
  font-size: 13px !important;
  color: rgba(180, 197, 214, 0.64) !important;
  pointer-events: none !important;
}
.tbp-platform--register.tbp-platform--mobile .tbp-register-form {
  padding: 84px 18px 86px !important;
  justify-content: flex-start !important;
}
.tbp-platform--register.tbp-platform--mobile .tbp-register-mobile-body {
  width: min(100%, 560px) !important;
  margin: 0 auto !important;
}
.tbp-platform--register.tbp-platform--mobile .tbp-register-footer {
  position: static !important;
  flex-direction: column !important;
  gap: 6px !important;
  margin: 28px 22px 18px !important;
  text-align: center !important;
}
@media (max-width: 1100px) {
  .tbp-platform--register.tbp-platform--desktop { grid-template-columns: 100px minmax(0,1fr) !important; }
  .tbp-platform--register .tbp-register-footer { left: 112px !important; }
}
@media (max-width: 760px) {
  .tbp-platform--register.tbp-platform--desktop { display: block !important; }
  .tbp-platform--register.tbp-platform--desktop .tbp-register-sidebar { display:none !important; }
  .tbp-platform--register.tbp-platform--desktop .tbp-register-form { min-height: auto !important; padding-top: 84px !important; }
  .tbp-platform--register .tbp-register-footer { position: static !important; margin-top: 26px !important; flex-direction: column !important; gap: 6px !important; left: auto !important; right: auto !important; }
  .tbp-platform--register .tbp-register-body,
  .tbp-platform--register .tbp-register-mobile-body { padding: 24px 18px !important; border-radius: 20px !important; }
  .tbp-platform--register .tbp-register-names { grid-template-columns: 1fr !important; gap: 0 !important; }
  .tbp-platform--register .tbp-register-title { font-size: 34px !important; }
}

/* Short laptop viewports: keep the desktop design, allow all fields and footer to be reached. */
@media (max-height: 900px) and (min-width: 761px) {
  .tbp-platform--register.tbp-platform--desktop {
    height: 100dvh !important;
    min-height: 100dvh !important;
    max-height: none !important;
    overflow-y: auto !important;
    overflow-x: hidden !important;
    align-items: start !important;
  }
  .tbp-platform--register.tbp-platform--desktop .tbp-register-form {
    height: auto !important;
    min-height: 100dvh !important;
    justify-content: flex-start !important;
    padding-bottom: 40px !important;
  }
  .tbp-platform--register.tbp-platform--desktop .tbp-register-footer {
    position: static !important;
    left: auto !important;
    right: auto !important;
    bottom: auto !important;
    margin-top: 28px !important;
    flex-shrink: 0 !important;
  }
}
              `}</style>

              
  
        
              <Modal centered={false} dimmer={{ className: 'tbp-register-backdrop' }} className={'tbp-desktop-modal tbp-register-overlay ' + (that.state.mode_light_dark == 'light' ? 'light' : 'dark')} open={Boolean(that.state.errorTags)}>
                <Modal.Header>The Blender Platform</Modal.Header>
                <Modal.Content><div className="tbp-register-message">{that.state.errorTags}</div></Modal.Content>
                <Modal.Actions><Button onClick={() => that.setState({ errorTags: null })}>{that.state.selectedLanguage == 'spanish' ? 'Aceptar' : 'Okay'}</Button></Modal.Actions>
              </Modal>
  
  
              <Modal centered={false} dimmer={{ className: 'tbp-register-backdrop' }} className={'tbp-desktop-modal tbp-register-overlay ' + (that.state.mode_light_dark == 'light' ? 'light' : 'dark')} open={that.state.termsAndConfirmationCodeOverlay}>
                <Modal.Header>The Blender Platform</Modal.Header>
                <Modal.Content>
                  <h3>{that.state.termsAcceptedBool ? (that.state.accountConfirmed ? (that.state.selectedLanguage == 'spanish' ? 'Terminar la configuración' : 'Finish Account Setup') : (that.state.selectedLanguage == 'spanish' ? 'Verifica tu correo electrónico' : 'Verify Your Email')) : (that.state.selectedLanguage == 'spanish' ? 'Términos de Uso y Política de Privacidad' : 'Terms of Use & Privacy Policy')}</h3>
                  {!that.state.termsAcceptedBool ? (
                    <div className="tbp-register-modal-buttons">
                      <Button disabled={that.state.registrationLoading} onClick={() => window.open('https://lenderblockcorp.com/termsandconditions-tbp', '_blank', 'noopener,noreferrer')}>{that.state.selectedLanguage == 'spanish' ? 'Revisar los Términos de Uso' : 'Review Terms of Use'}</Button>
                      <Button disabled={that.state.registrationLoading} onClick={() => window.open('https://lenderblockcorp.com/privacypolicy-tbp', '_blank', 'noopener,noreferrer')}>{that.state.selectedLanguage == 'spanish' ? 'Revisar la Política de Privacidad' : 'Review Privacy Policy'}</Button>
                      <Button disabled={that.state.registrationLoading} onClick={async () => {
                        await that.showRegistrationLoading(that.state.selectedLanguage == 'spanish' ? 'Continuando…' : 'Continuing…');
                        that.setState({ termsAcceptedBool: true, registrationLoading: false, freezeButtonsBool: false });
                      }}>{that.state.selectedLanguage == 'spanish' ? 'Acepto los Términos de Uso y la Política de Privacidad' : 'I Accept the Terms of Use & Privacy Policy'}</Button>
                    </div>
                  ) : (
                    <div>
                      {!that.state.accountConfirmed && <div>
                        <p>{that.state.selectedLanguage == 'spanish' ? 'Ingresa el código de 6 dígitos enviado a tu correo.' : 'Enter the 6-digit code sent to your email.'}</p>
                        <input name="one-time-code" id="authCode" type="text" inputMode="numeric" autoComplete="one-time-code" maxLength={6} aria-label={that.state.selectedLanguage == 'spanish' ? 'Código de verificación' : 'Verification Code'} placeholder="000000" value={that.state.authCode || ''} disabled={that.state.registrationLoading} onChange={event => that.setState({ authCode: event.target.value.replace(/\D/g, '').slice(0, 6) })} />
                      </div>}
                      {that.state.verificationError && <p className="tbp-register-error" role="alert">{that.state.verificationError}</p>}
                      {that.state.verificationNotice && <p role="status">{that.state.verificationNotice}</p>}
                      <div className="tbp-register-modal-buttons">
                        <Button disabled={that.state.registrationLoading || (!that.state.accountConfirmed && !/^\d{6}$/.test(that.state.authCode || ''))} onClick={() => that.confirmSignUp()}>{that.state.accountConfirmed ? (that.state.selectedLanguage == 'spanish' ? 'Continuar' : 'Continue') : (that.state.selectedLanguage == 'spanish' ? 'Confirmar' : 'Confirm')}</Button>
                        {!that.state.accountConfirmed && <Button className="tbp-register-secondary" disabled={that.state.registrationLoading} onClick={() => that.resendConfirmationCode()}>{that.state.selectedLanguage == 'spanish' ? 'Enviar otro código' : 'Resend Code'}</Button>}
                      </div>
                    </div>
                  )}
                  {that.state.registrationLoading && <div className="tbp-register-loading" role="status" aria-live="polite"><span className="tbp-register-spinner" aria-hidden="true" /><span>{that.state.loadingText}</span></div>}
                </Modal.Content>
              </Modal>
  
  
              <Modal centered={false} dimmer={{ className: 'tbp-register-backdrop' }} className={'tbp-desktop-modal tbp-register-overlay ' + (that.state.mode_light_dark == 'light' ? 'light' : 'dark')} open={Boolean(that.state.registrationLoading && !that.state.termsAndConfirmationCodeOverlay)}>
                <Modal.Header>The Blender Platform</Modal.Header>
                <Modal.Content><div className="tbp-register-loading" role="status" aria-live="polite"><span className="tbp-register-spinner" aria-hidden="true" /><span>{that.state.loadingText}</span></div></Modal.Content>
              </Modal>
              
              
            
              <div className="tbp-register-sidebar" 
                  style={{
                  borderRadius: 28,
                  // backgroundColor: 'purple',
                  justifyContent: 'center',
                  alignItems: 'center',
                  width: '25vw',
                  height: '100vh',
                  margin: 0,
                  borderWidth: 0,
                  zIndex: 99999,
                  overflow: 'hidden',
                  borderTopLeftRadius: 0,
                  borderBottomLeftRadius: 0,
                  backgroundClip: 'padding-box',

                  borderRightStyle: 'solid',
                  borderWidth: 0.1,
                  borderColor: 'rgba(12, 12, 12, 0.4)',
              }}>
              
                  <img 
                    // className="logoImage" 
                    src="https://lenderblockpublicicons.s3.amazonaws.com/TBPLogoSquare.png"
                    style={{
                      position: 'relative',
                      left: '7vw',
                      top: '3.5vw',
                      height: '10vw',
                      width: '10vw',
                      marginBottom: '2vh',
                      borderStyle: 'solid',
                      borderRadius: '6.5vw', 
                      borderWidth: 2,
                      borderColor: 'rgba(177, 177, 177, 1)', 
                    }}
                  />
  
  
  
              </div>
                  
                
  
              <div className="tbp-register-form" 
                style={{
                  // backgroundColor: 'blue',
                  borderRadius: 28,
                  justifyContent: 'center',
                  alignItems: 'center',
                  width: '50vw',
                  height: '100vh',
                  margin: 0,
                  flexDirection: 'column',
                  borderWidth: 0,    
                  // border: 'none',   
                  // borderColor: 'rgba(177, 177, 177, 0)',
                }}
              >
              
                <div className="tbp-register-heading" style={{
                  // backgroundColor: 'rgba(0, 158, 129, 0)',
                  borderRadius: 28,
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  width: '44vw',
                  height: '15vh',
                  marginLeft: '3vw',
                  marginRight: '3vw',
                  display: 'flex',
                  flexDirection: 'row',
                  borderBottomWidth: 1,
                  borderBottomColor: 'rgba(255, 255, 255, 1)',
                  borderBottomStyle: 'solid',
                  // borderWidth: 0,
                }}>
  
                  
  
                  <div className="tbp-register-hero">
                    <p className="tbp-register-kicker">{that.state.selectedLanguage == 'spanish' ? 'Registro' : 'Registration'}</p>
                    <p className="tbp-register-title">{that.state.selectedLanguage == 'spanish' ? 'Crea tu cuenta Blender.' : 'Create your Blender account.'}</p>
                    <p className="tbp-register-subtitle">{!that.state.registrationCompleteA
                      ? (that.state.selectedLanguage == 'spanish'
                          ? 'Comencemos con tus datos básicos. Usa tu nombre legal y continúa con una experiencia de incorporación más clara y moderna.'
                          : 'Start with your basic details. Use your legal name and continue through a cleaner, more modern onboarding experience.')
                      : (that.state.selectedLanguage == 'spanish'
                          ? 'Ahora crea tus credenciales seguras para completar el registro.'
                          : 'Now create your secure credentials to finish registration.')}</p>
                  </div>
                </div>
  
  
  
                <form autoComplete="on" onSubmit={event => { event.preventDefault(); if (that.state.registrationCompleteA) that.submitRegistration(); else that.goToCredentials(); }} className="tbp-register-body">
                  {!that.state.registrationCompleteA ? (
                    <div>
                      <p 
                                    style={{ 
                                      textAlign: 'left',
                                      textAlignVertical: 'center',
                                      fontSize: 16, 
                                      fontWeight: '600', 
                                      color: 'rgba(177, 177, 177, 1)',
                                      marginBottom: 30,
                                      // textUnderlineOffset: 3, 
                                      // textDecorationLine: 'underline', 
                                      // textDecorationColor: 'rgba(255, 255, 255, 1)',
                                    }}
                                  >
                                    {that.state.selectedLanguage == 'spanish' ? 
                                      'Ingrese su nombre y apellido tal como aparecen en su identificación gubernamental.'
                                        :
                                      'Enter your first and last name as they appear on your government ID.'
                                    }
                                  </p>
                      <div className="tbp-register-names"><input name="given-name" 
                                      type="text" 
                                      id="firstName" 
                                      outline="none"
                                      autoComplete="given-name"
                                      onChange={(event) => {
                                          that.setState({
                                            firstName: event.target.value
                                          })
                                      }} 
                                      value={that.state.firstName || ''}
                                      maxLength={20}
                                      placeholder={
                                        that.state.selectedLanguage == 'spanish' ? 
                                          "Nombre"
                                            :
                                          "First Name"
                                      }
                                      style={{
                                        fontWeight: '600',
                                        fontFamily: 'arial',
                                        color: 'rgba(0, 0, 0, 1)',
                                        padding: 20,
                                        textAlign: 'left',
                                        textAlignVertical: 'center',
                                        height: '5vh',
                                        width: '21.5vw',
                                        borderRadius: 0,
                                        borderWidth: 1,
                                        fontSize: 20,
                                        borderBottomColor: 'rgba(177, 177, 177, 0)',
                                        backgroundColor: 'rgba(226, 226, 226, 1)',
                                      }}
                                    />
<input name="family-name" 
                                      type="text" 
                                      id="lastName" 
                                      outline="none"
                                      autoComplete="family-name"
                                      maxLength={20}
                                      onChange={(event) => {
                                          that.setState({
                                            lastName: event.target.value
                                          })
                                      }} 
                                      value={that.state.lastName || ''}
                                      placeholder={
                                        that.state.selectedLanguage == 'spanish' ? 
                                          "Apellido"
                                            :
                                          "Last Name"
                                      } 
                                      style={{
                                        fontWeight: '600',
                                        fontFamily: 'arial',
                                        color: 'rgba(0, 0, 0, 1)',
                                        padding: 20,
                                        textAlign: 'left',
                                        textAlignVertical: 'center',
                                        height: '5vh',
                                        width: '21.5vw',
                                        borderRadius: 0,
                                        borderWidth: 1,
                                        fontSize: 20,
                                        borderBottomColor: 'rgba(177, 177, 177, 0)',
                                        backgroundColor: 'rgba(226, 226, 226, 1)',
                                      }}
                                    /></div>
                      <Dropdown
                                      className="tbp-register-country"
                                      search
                                      value={that.state.country || undefined}
                                      text={countryCodesJSON.find(option => option.value === that.state.country)?.text || undefined}
                                      aria-label={that.state.selectedLanguage === 'spanish' ? 'País' : 'Country'}
                                      noResultsMessage={that.state.selectedLanguage == 'spanish' ? 'No se encontraron países' : 'No countries found'}
                                      placeholder={that.state.selectedLanguage == 'spanish' ? 
                                        'País'
                                        :
                                        'Country'
                                      }
                                      fluid
                                      selection
                                      style={{
                                        fontWeight: '600',
                                        fontFamily: 'arial',
                                        color: 'rgba(0, 0, 0, 1)',
                                        padding: 20,
                                        textAlign: 'left',
                                        textAlignVertical: 'center',
                                        height: '5vh',
                                        width: '44vw',
                                        borderRadius: 0,
                                        borderWidth: 1,
                                        fontSize: 20,
                                        borderBottomColor: 'rgba(177, 177, 177, 0)',
                                        backgroundColor: 'rgba(226, 226, 226, 1)',
                                      }}
                                      options={countryCodesJSON}
                                      onMouseDown={() => {
                                        that.setState({
                                          dropDownActiveBool: true,
                                        })
                                      }}
                                      onClose={() => {
                                        that.setState({
                                          dropDownActiveBool: false,
                                        })
                                      }}
                                      onChange={(event, data) => {
                                        const selectedCountry = countryCodesJSON.find(country => country.value === data.value);
                                        that.setState({
                                          dropDownActiveBool: false,
                                          country: data.value,
                                        })
  
                                        if(selectedCountry){
                                          if(selectedCountry.hasOwnProperty('key')){
                                            that.setState({
                                              countryCode: selectedCountry.key,
                                            })
                                          }
                                        }
                                    }} 
                                    />
                      <div className="tbp-register-action"><Button 
                                    type="submit"
                                    disabled={
                                      String(that.state.firstName).length < 2 ||
                                      String(that.state.lastName).length < 2 ||
                                      String(that.state.country).length < 2
                                    }
                                    style={{
                                      width: '42vw',
                                      height: '6vh',
                                      marginRight: '3vw',
                                      borderColor: 'rgba(256, 256, 256, 1)',
                                      borderRadius: 0, 
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      zIndex: 9999,
                                      marginBottom: 35,
                                    }}
                                  >                  
                                    <p style={{ fontSize: 23, textAlign: 'center', position: 'relative' , textAlignVertical: 'top', fontWeight: '600', marginBottom: 5, color: 'rgba(0, 158, 129, 1)', }}> 
                                    {that.state.selectedLanguage == 'spanish' ? 
                                        'Entregar'
                                          :
                                        'Submit'
                                      }
                                    </p>
                                  </Button></div>
                    </div>
                  ) : (
                    <div>
                      <div 
                                    style={{ 
                                      textAlign: 'left',
                                      textAlignVertical: 'center',
                                      fontSize: 15, 
                                      fontWeight: '600', 
                                      color: 'rgba(177, 177, 177, 1)',
                                      marginTop: 30, 
                                      marginBottom: 5,
                                      // textUnderlineOffset: 3, 
                                      // textDecorationLine: 'underline', 
                                      // textDecorationColor: 'rgba(255, 255, 255, 1)',
                                    }}
                                  >
                                    {that.state.selectedLanguage == 'spanish' ? 
                                      '\n\nAhorrar su Contraseña de Blender.'
                                        :
                                      '\n\nSave and Secure Your Blender Credentials.'
                                    }
  
                                    <p 
                                      style={{ 
                                        textAlign: 'left',
                                        textAlignVertical: 'center',
                                        fontSize: 15, 
                                        fontWeight: '600', 
                                        color: 'rgba(177, 177, 177, 1)',
                                        marginTop: 5, 
                                        marginBottom: 30,
                                        // textUnderlineOffset: 3, 
                                        // textDecorationLine: 'underline', 
                                        // textDecorationColor: 'rgba(255, 255, 255, 1)',
                                      }}
                                    >
                                      {that.state.selectedLanguage == 'spanish' ? 
                                        'Contraseñas deben contener 2 números, 2 letras mayúsculas, 2 letras minúsculas, y 2 carácteres especiales.'
                                          :
                                        'Passwords must contain 2 numbers, 2 uppercase letters, 2 lowercase letters, and 2 special characters.'
                                      }
                                    </p>
                                  </div>
                      <input name="email"
                                      type="email"
                                      id="emailAddress"
                                      autoComplete="email"
                                      onChange={(event) => {
                                        that.setState({ emailAddress: event.target.value })
                                      }}
                                      value={that.state.emailAddress || ''}
                                      maxLength={254}
                                      placeholder={that.state.selectedLanguage == 'spanish' ? 'Dirección de Email' : 'Email Address'}
                                      aria-label={that.state.selectedLanguage == 'spanish' ? 'Dirección de Email' : 'Email Address'}
                                    />
                      <input name="username" 
                                      type="text" 
                                      id="username" 
                                      outline="none"
                                      autoComplete="username"
                                      onChange={(event) => {
                                          that.setState({
                                            username: event.target.value
                                          })
                                      }} 
                                      value={that.state.username || ''}
                                      maxLength={15}
                                      placeholder={
                                        that.state.selectedLanguage == 'spanish' ? 
                                          "Usuario"
                                            :
                                          "Username"
                                      } 
                                      style={{
                                        fontWeight: '600',
                                        fontFamily: 'arial',
                                        color: 'rgba(0, 0, 0, 1)',
                                        padding: 20,
                                        textAlign: 'left',
                                        textAlignVertical: 'center',
                                        height: '5vh',
                                        width: '44vw',
                                        borderRadius: 0,
                                        borderWidth: 1,
                                        fontSize: 20,
                                        borderBottomColor: 'rgba(177, 177, 177, 0)',
                                        backgroundColor: 'rgba(226, 226, 226, 1)',
                                      }}
                                    />
                      <input name="new-password" 
                                      type="password" 
                                      id="password" 
                                      outline="none"
                                      autoComplete="new-password"
                                      onChange={(event) => {
                                          that.setState({
                                            password: event.target.value
                                          })
                                      }} 
                                      value={that.state.password || ''}
                                      maxLength={20}
                                      placeholder={
                                        that.state.selectedLanguage == 'spanish' ? 
                                          "Contraseña"
                                            :
                                          "Password"
                                      } 
                                      style={{
                                        fontWeight: '600',
                                        fontFamily: 'arial',
                                        color: 'rgba(0, 0, 0, 1)',
                                        padding: 20,
                                        textAlign: 'left',
                                        textAlignVertical: 'center',
                                        height: '5vh',
                                        width: '44vw',
                                        borderRadius: 0,
                                        borderWidth: 1,
                                        fontSize: 20,
                                        borderBottomColor: 'rgba(177, 177, 177, 0)',
                                        backgroundColor: 'rgba(226, 226, 226, 1)',
                                      }}
                                    />
                      <input name="confirm-password" 
                                      type="password" 
                                      id="passwordConf" 
                                      outline="none"
                                      autoComplete="new-password"
                                      onChange={(event) => {
                                          that.setState({
                                            passwordConfirm: event.target.value
                                          })
                                      }} 
                                      value={that.state.passwordConfirm || ''}
                                      maxLength={20}
                                      placeholder={
                                        that.state.selectedLanguage == 'spanish' ? 
                                          "Contraseña Confirmada"
                                            :
                                          "Confirm Password"
                                      }
                                      style={{
                                        fontWeight: '600',
                                        fontFamily: 'arial',
                                        color: 'rgba(0, 0, 0, 1)',
                                        padding: 20,
                                        textAlign: 'left',
                                        textAlignVertical: 'center',
                                        height: '5vh',
                                        width: '44vw',
                                        borderRadius: 0,
                                        borderWidth: 1,
                                        fontSize: 20,
                                        borderBottomColor: 'rgba(177, 177, 177, 0)',
                                        backgroundColor: 'rgba(226, 226, 226, 1)',
                                      }}
                                    />
                      <div className="tbp-register-action"><Button 
                                    type="submit"
                                    disabled={
                                      that.state.freezeButtonsBool ||
                                      !String(that.state.emailAddress).includes('@') ||
                                      !String(that.state.emailAddress).includes('.') ||
                                      String(that.state.username).length < 2 ||
                                      String(that.state.password).length < 2 ||
                                      String(that.state.passwordConfirm).length < 2 
                                    }
                                    style={{
                                      width: '42vw',
                                      height: '6vh',
                                      marginRight: '3vw',
                                      borderColor: 'rgba(256, 256, 256, 1)',
                                      borderRadius: 0, 
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      zIndex: 9999,
                                      marginBottom: 35,
                                    }}
                                  >                  
                                    <p style={{ fontSize: 23, textAlign: 'center', position: 'relative' , textAlignVertical: 'top', fontWeight: '600', marginBottom: 5, color: 'rgba(0, 158, 129, 1)', }}> 
                                    {that.state.selectedLanguage == 'spanish' ? 
                                        'Confirmar'
                                          :
                                        'Confirm'
                                      }
                                    </p>
                                  </Button></div>
                    </div>
                  )}
                  <div className="tbp-register-login-return">
                    <Link to="/welcome" aria-label={that.state.selectedLanguage === 'spanish' ? 'Volver a iniciar sesión' : 'Back to Sign In'}>
                      <span aria-hidden="true">←</span>
                      {that.state.selectedLanguage === 'spanish' ? 'Volver a iniciar sesión' : 'Back to Sign In'}
                    </Link>
                  </div>
                </form>

                <aside className="tbp-register-guide" aria-label={that.state.selectedLanguage === 'spanish' ? 'Pasos del registro' : 'Registration steps'}>
                  <div className="tbp-register-guide__visual" aria-hidden="true">
                    <span className="tbp-register-guide__orbit tbp-register-guide__orbit--one" />
                    <span className="tbp-register-guide__orbit tbp-register-guide__orbit--two" />
                    <span className="tbp-register-guide__visual-blob tbp-register-guide__visual-blob--one" />
                    <span className="tbp-register-guide__visual-blob tbp-register-guide__visual-blob--two" />
                    <span className="tbp-register-guide__visual-card tbp-register-guide__visual-card--back" />
                    <span className="tbp-register-guide__visual-card tbp-register-guide__visual-card--front" />
                  </div>
                  <p className="tbp-register-guide__kicker">{that.state.selectedLanguage === 'spanish' ? 'TU CAMINO EN BLENDER' : 'YOUR BLENDER JOURNEY'}</p>
                  <h2>{that.state.selectedLanguage === 'spanish' ? 'Todo comienza aquí.' : 'It starts here.'}</h2>
                  <p className="tbp-register-guide__intro">{that.state.selectedLanguage === 'spanish'
                    ? 'Crea tu perfil y accede a una experiencia financiera conectada.'
                    : 'Create your profile and access a connected financial experience.'}</p>
                  <div className="tbp-register-guide__steps">
                    <div className="tbp-register-guide__step">
                      <span>01</span><div><strong>{that.state.selectedLanguage === 'spanish' ? 'Tus datos' : 'Your details'}</strong>
                      <small>{that.state.selectedLanguage === 'spanish' ? 'Ingresa tu nombre y país.' : 'Enter your name and country.'}</small></div>
                    </div>
                    <div className="tbp-register-guide__step">
                      <span>02</span><div><strong>{that.state.selectedLanguage === 'spanish' ? 'Tu cuenta' : 'Your account'}</strong>
                      <small>{that.state.selectedLanguage === 'spanish' ? 'Configura tus credenciales.' : 'Set up your credentials.'}</small></div>
                    </div>
                    <div className="tbp-register-guide__step">
                      <span>03</span><div><strong>{that.state.selectedLanguage === 'spanish' ? 'Verificación' : 'Verification'}</strong>
                      <small>{that.state.selectedLanguage === 'spanish' ? 'Confirma tu dirección de correo.' : 'Confirm your email address.'}</small></div>
                    </div>
                  </div>
                </aside>

                <div className="tbp-register-language-wrapper"
                  style={{
                      justifyContent: 'center',
                      alignItems: 'right',
                      width: '65vw',
                      height: '25vh',
                      position: 'fixed',
                      top: '0vw',
                      left: '25vw',
                      paddingLeft: '15vw',
                  }}
                >
                  
                  <button type="button" className="tbp-register-language-control" aria-label={that.state.selectedLanguage === 'spanish' ? 'Switch language to English' : 'Cambiar idioma a Español'} onClick={() => {
                            const next = that.state.selectedLanguage === 'spanish' ? 'english' : 'spanish';
                            that.setState({ selectedLanguage: next });
                            try { localStorage.setItem('primaryLanguage', next); }
                            catch (error) { /* Browser storage may be unavailable. */ }
                        }}>
                        <svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.5"/><path d="M3 12h18M12 3c3 3 4.4 6 4.4 9S15 18 12 21c-3-3-4.4-6-4.4-9S9 6 12 3Z" stroke="currentColor" strokeWidth="1.5"/></svg>
                        {that.state.selectedLanguage === 'spanish' ? 'English' : 'Español'}
                    </button>
  
                </div>
  
  
              </div>
            </div>
        )
    );
  }
}

export default RegisterDesktopRender;
